/* eslint-disable */
import * as React from "react";

import { ReportRenderer } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { IndexEndHierarchyControl } from "../controls/IndexEndHierarchyControl";
import { IndexStartHierarchyControl } from "../controls/IndexStartHierarchyControl";

import { useSubscription } from "./useSubscription";

export default function () {
  useSubscription();
  return (
    <>
      <ReportToolbarGroup>
        <IndexStartHierarchyControl />
        <IndexEndHierarchyControl />
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
          <ReportRenderer componentId="tables" />
        </ReportGrid>
      </div>
    </>
  );
}
